export default function convertToSlug (item: any) {
    return `${item.name}`.toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');
}
